import { memo } from 'react';

import { LinkIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

type ShareButtonProps = ButtonProps & {
  dataTestId?: string;
};

export const ShareButton = memo(({ dataTestId, ...props }: ShareButtonProps) => {
  return (
    <Button appearance="outline" color="gray" data-testid={dataTestId} size="medium" {...props}>
      <div className="flex items-center gap-1 text-12">
        <LinkIcon size="sm" />
        Share
      </div>
    </Button>
  );
});

ShareButton.displayName = 'ShareButton';
